module.exports = {
      id: "comm-environment-usage",
      viewBox: "0 0 276.484 47.102",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-environment",
      toString: function () {
        return this.url;
      }
    }